import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;

  max-width: 1440px;
  margin: 0 auto;

  padding: 0 20px;
  overflow: hidden;
`;

export default Container;
